import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface RouterState {
  mode: string
  connectedAccount: string
}

const initialState: RouterState = {
  mode: 'root',
  connectedAccount: null,
}

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    setConnectedAccount(
      state,
      action: PayloadAction<{ mode: string; connectedAccount: string }>
    ) {
      state.mode = action.payload.mode
      state.connectedAccount = action.payload.connectedAccount
    },
  },
})

export const routerReducer = routerSlice.reducer
export const routerReducers = { ...routerSlice.actions }
